import { selectDate } from "../../types/Reievespf002";

/**
 * 
 * @param props 出席する日付の選択肢
 * @returns 
 */
export function SelectDate(props: selectDate){
    //  日付をyyyy年mm月dd日の形に変換
    const day = new Date(props.date)
    const formatDay = day.toLocaleDateString("ja-JP", {year: "numeric", month: "short", day:"numeric"})

    return (
        <>
            <option value={formatDay}>{formatDay}</option>

        </>       
    )
    
}